import React, { useEffect, useState } from "react";

interface VidyardPlayerProps {
  uuid: string;
  type?: "inline" | "lightbox";
  autoPlay?: boolean;
}

const VidyardPlayer: React.FC<VidyardPlayerProps> = ({ uuid, type = "inline", autoPlay = false }) => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  // Load script only once
  useEffect(() => {
    if (!window.VidyardV4) {
      const script = document.createElement("script") as HTMLScriptElement;
      script.src = "https://play.vidyard.com/embed/v4.js";
      script.referrerPolicy = "no-referrer";
      script.async = true;
      script.onload = () => setScriptLoaded(true);
      document.body.appendChild(script);
    } else {
      setScriptLoaded(true);
    }
  }, []);

  // Trigger the Vidyard render when uuid or script state changes
  useEffect(() => {
    if (scriptLoaded && window.VidyardV4?.api) {
      window.VidyardV4.api.renderDOMPlayers();
    }
  }, [uuid, scriptLoaded]);

  return (
    <div className="vidyard-player video has-play-btn g-0">
      <div className="video-container">
        <div
          key={uuid} 
          className="vidyard-player-embed"
          data-uuid={uuid}
          data-v="4"
          data-type={type}
          {...(type === "lightbox" ? { "data-lightbox": "true" } : {})}
          {...(autoPlay ? { "data-autoplay": "1" } : {})}
        />
      </div>
    </div>
  );
};

export default VidyardPlayer;
